import { FormEvent, useState } from "react";
import { ArrowRight, Eye, EyeOff, KeyRound } from "lucide-react";
import { ApiError } from "../api";

export function LoginPage({ onLogin }: { onLogin: (email: string, password: string) => Promise<void> }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true); setError("");
    try { await onLogin(email, password); }
    catch (reason) { setError(reason instanceof ApiError ? reason.message : "Сервер недоступен. Проверьте соединение."); }
    finally { setBusy(false); }
  }

  return <main className="login-page">
    <section className="login-visual">
      <div className="login-visual__grid" />
      <div className="login-visual__content">
        <span className="eyebrow">Адресное хранение</span>
        <h1>Каждый товар.<br />На своём месте.</h1>
        <p>Приём заказов из 1С, точная сборка по ячейкам и полный контроль выдачи.</p>
        <div className="login-stat"><b>01</b><span>Сканируйте ячейку</span></div>
        <div className="login-stat"><b>02</b><span>Подтвердите товар</span></div>
        <div className="login-stat"><b>03</b><span>Соберите без ошибок</span></div>
      </div>
    </section>
    <section className="login-form-wrap">
      <form className="login-form" onSubmit={submit}>
        <div className="login-logo nord-brand-lockup"><img className="nord-logo nord-logo--large" src="/brand/nord.svg" alt="Nord — оконные системы"/><small className="nord-service-label">Складская система WMS</small></div>
        <div className="login-heading"><span className="eyebrow">Вход для сотрудников</span><h2>Добро пожаловать</h2><p>Используйте рабочую учётную запись.</p></div>
        {error && <div className="alert alert--error" role="alert">{error}</div>}
        <label className="field"><span>Электронная почта</span><input type="email" autoComplete="username" value={email} onChange={e => setEmail(e.target.value)} required autoFocus placeholder="name@company.kg" /></label>
        <label className="field"><span>Пароль</span><div className="password-field"><KeyRound size={18} /><input type={showPassword ? "text" : "password"} autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} required /><button type="button" onClick={() => setShowPassword(x => !x)} aria-label={showPassword ? "Скрыть пароль" : "Показать пароль"}>{showPassword ? <EyeOff /> : <Eye />}</button></div></label>
        <button className="button button--primary button--large" disabled={busy}>{busy ? <span className="spinner" /> : <>Войти в систему <ArrowRight size={19} /></>}</button>
        <p className="login-help">Доступ выдаёт администратор склада. Пароли и данные не сохраняются на устройстве.</p>
      </form>
    </section>
  </main>;
}

